import { render, staticRenderFns } from "./PatchActionForm.vue?vue&type=template&id=8a91479e&scoped=true"
import script from "./PatchActionForm.vue?vue&type=script&lang=js"
export * from "./PatchActionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a91479e",
  null
  
)

export default component.exports